import { Injectable } from '@angular/core';
import { DataService } from 'app/shared/services/data.service';
import { ConfigurationService } from 'app/shared/services/configuration.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IResult } from 'app/shared/models/result.model';
import { IDtoPeriod } from 'app/shared/models/payroll/dto-period.model';
import { IDtoMovementRestrictionCalendar } from 'app/shared/models/payroll/dto-movement-restriction-calendar.model';
import { IDtoPayrollEmployee } from 'app/shared/models/employee/dto-payroll-employee.model';
import { IDtoEmployeeFilter } from 'app/shared/models/employee/dto-employee-filter.model';
import { IGeneralData } from 'app/shared/models/recruitment/general-data.model';
import { IDtoCatalog } from 'app/shared/models/dto-catalog.model';
import { ISelect } from 'app/shared/models/select.model';
import { IStudy } from 'app/shared/models/recruitment/study.model';
import { IDtoEmployeeBasicData } from 'app/shared/models/employee/dto-employee-basic-data.model';
import { IDtoEmployeePaymentData } from 'app/shared/models/employee/dto-employee-payment-data.model';
import { IDtoPayrollEmployeeDetail } from 'app/shared/models/employee/dto-payroll-employee-detail.model';
import { IDtoEmployee } from 'app/shared/models/employee/dto-employee.model';
import { IDtoLiquidation } from 'app/shared/models/legal/dto-liquidation.model';
import { IDtoSettlement } from 'app/shared/models/legal/dto-settlement.model';
import { IDtoDiscountDismissal } from 'app/shared/models/legal/dto-discount-dismissal.model';

@Injectable()
export class LiquidationService {
  private requestUrl = '';
  private recruitmentUrl = '';
  private moneyUrl = '';
  constructor(private service: DataService, private configurationService: ConfigurationService) {
    if (this.configurationService.isReady) {
      this.requestUrl = this.configurationService.serverSettings.requestUrl;
      this.recruitmentUrl = this.configurationService.serverSettings.recruitmentUrl;
      this.moneyUrl = this.configurationService.serverSettings.moneyUrl;
    } else {
      this.configurationService.settingsLoaded$.subscribe(x => {
        this.requestUrl = this.configurationService.serverSettings.requestUrl;
        this.recruitmentUrl = this.configurationService.serverSettings.recruitmentUrl;
        this.moneyUrl = this.configurationService.serverSettings.moneyUrl;
      });
    }
  }
  public getliquidation(dto: IDtoLiquidation): Observable<IResult> {
    const url = `${this.requestUrl}api/Liquidations/getliquidation/`;
    return this.service.post(url, dto).pipe(map((response: any) => {
      return response;
    }));
  }
  public getDetailSettlementEmployee(dto: IDtoLiquidation): Observable<IResult> {
    const url = `${this.requestUrl}api/Liquidations/getDetailSettlementEmployee/`;
    return this.service.post(url, dto).pipe(map((response: any) => {
      return response;
    }));
  }
  public addLiquidation(dto: IDtoLiquidation): Observable<IResult> {
    const url = `${this.requestUrl}api/Liquidations/addLiquidation/`;
    return this.service.post(url, dto).pipe(map((response: any) => {
      return response;
    }));
  }
  public getLiquidationsByStatusId(statusId: number): Observable<IResult> {
    const url = `${this.requestUrl}api/Liquidations/getLiquidationsByStatusId?statusId=${statusId}`;
    return this.service.get(url)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }
  public getLiquidationById(liquidationId: number): Observable<IDtoLiquidation> {
    const url = `${this.requestUrl}api/Liquidations/getLiquidationById?liquidationId=${liquidationId}`;
    return this.service.get(url)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }
  public updateLiquidation(dto: IDtoLiquidation): Observable<IResult> {
    const url = `${this.requestUrl}api/Liquidations/updateLiquidation/`;
    return this.service.putWithId(url, dto).pipe(map((response: any) => {
      return response;
    }));
  }
  public getApproverConciliationOwn(): Observable<IResult> {
    const url = `${this.requestUrl}api/Approvers/getApproverConciliationOwn`;
    return this.service.get(url)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }
  public approveOwnConciliation(liquidationId: number): Observable<IResult> {
    const url = `${this.requestUrl}api/Liquidations/approveOwnConciliation?liquidationId=${liquidationId}`;
    return this.service.get(url).pipe(map((response: any) => {
      return response;
    }));
  }
  public sentRequestMoney(dto: IDtoLiquidation): Observable<IResult> {
    const url = `${this.requestUrl}api/Liquidations/sentRequestMoney/`;
    return this.service.post(url, dto).pipe(map((response: any) => {
      return response;
    }));
  }
  public hasLiquidation(employeeId: number, requisitionId: number): Observable<IResult> {
    const url = `${this.requestUrl}api/Liquidations/hasLiquidation?employeeId=${employeeId}&requisitionId=${requisitionId}`;
    return this.service.get(url)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }
  public downloadFileLiquidation(employeeId: number, liquidationId: number, requisitionId: number): Observable<IResult> {
    const url = `${this.recruitmentUrl}api/Templates/getLiquidation?employeeId=${employeeId}&liquidationId=${liquidationId}&requisitionId=${requisitionId}`;
    return this.service.get(url).pipe(map((response: any) => {
      return response;
    }));
  }
  public downloadFileLiquidationSimple(employeeId: number, liquidationId: number, requisitionId: number): Observable<IResult> {
    const url = `${this.recruitmentUrl}api/Templates/getLiquidationSimple?employeeId=${employeeId}&liquidationId=${liquidationId}&requisitionId=${requisitionId}`;
    return this.service.get(url).pipe(map((response: any) => {
      return response;
    }));
  }
  public obtenerDatosSolicitudDinero(idRegistroModulo: number, modulo: string): Observable<IResult> {
    const url = `${this.moneyUrl}api/Solicitudes/obtenerDatosSolicitud?idRegistroModulo=${idRegistroModulo}&modulo=${modulo}`;
    return this.service.get(url)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }
  public getCatalogDiscountTypes(): Observable<IDtoCatalog[]> {
    const url = `${this.requestUrl}api/DiscountTypes/getCatalogDiscountTypes`;
    return this.service.get(url)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }
  public getDiscountDismissals(employeeId: number, requisitionId: number): Observable<IDtoDiscountDismissal[]> {
    const url = `${this.requestUrl}api/DiscountDismissals/getDiscountDismissals?employeeId=${employeeId}&requisitionId=${requisitionId}`;
    return this.service.get(url)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }
  public addDiscountDismissal(dto: IDtoDiscountDismissal): Observable<IResult> {
    const url = `${this.requestUrl}api/DiscountDismissals/addDiscountDismissal/`;
    return this.service.post(url, dto).pipe(map((response: any) => {
      return response;
    }));
  }
  public deleteDiscountDismissal(id: number): Observable<IResult> {
    const url = `${this.requestUrl}api/DiscountDismissals/deleteDiscountDismissal?id=${id}`;
    return this.service.delete(url)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }
  public getFileLiquidations(init: string, end: string): Observable<IResult> {
    const url = `${this.requestUrl}api/Liquidations/getFileLiquidations?init=${init}&end=${end}`;
    return this.service.get(url)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }
}
